import { reportCashDiscountCustomersTypes } from "./types";

const {
  SET_CASH_DISCOUNT_CUSTOMERS_REPORT_FILTERS,
  RESTORE_INITIAL
} = reportCashDiscountCustomersTypes;

const initialState = {
  station: null,
};

export const reportCashDiscountCustomersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CASH_DISCOUNT_CUSTOMERS_REPORT_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
